import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Wallet, Smartphone, Phone } from "lucide-react";

interface PaymentMethodsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  tutorName?: string;
}

const PaymentMethodsModal = ({ open, onOpenChange, tutorName }: PaymentMethodsModalProps) => {
  const paymentMethods = [
    { name: "InstaPay", icon: Wallet },
    { name: "Fawry", icon: Wallet },
    { name: "Vodafone Cash", icon: Phone },
    { name: "Orange Cash", icon: Smartphone },
  ];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Payment Methods</DialogTitle>
          <DialogDescription>
            {tutorName ? `${tutorName} accepts the following payment methods:` : "Accepted payment methods:"}
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-3 py-4">
          {paymentMethods.map((method) => {
            const Icon = method.icon;
            return (
              <div
                key={method.name}
                className="flex items-center gap-3 p-3 rounded-lg border bg-card hover:bg-accent/50 transition-colors"
              >
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                  <Icon className="w-5 h-5 text-primary" />
                </div>
                <span className="font-medium text-foreground">{method.name}</span>
              </div>
            );
          })}
          
          {/* Alternative payment methods note */}
          <div className="mt-2 p-3 rounded-lg bg-muted/50 border border-muted">
            <p className="text-sm text-muted-foreground leading-relaxed">
              If your preferred payment method is not listed above, please don't hesitate to contact us. 
              We will work with you to find a suitable payment solution that meets your needs.
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentMethodsModal;
